import { z } from "zod";

const range = (min, max) =>
  Array.from({ length: max - min + 1 }, (_, i) => min + i);

export const DRIVER_AGES = [
  ...range(21, 29),
  "30-65"
];

const locationSchema = z.object({
  value: z.string(),
  label: z.string(),
  id: z.string(),
});

// Form tarafında başlangıçta null gelebilir diye nullable tanımlıyoruz
const nullableLocationSchema = locationSchema.nullable();

export const carSearchSchema = z
  .object({
    pickUpLocation: nullableLocationSchema,
    dropOffLocation: nullableLocationSchema,
    isDifferentLocation: z.boolean(),
  })
  .superRefine((data, ctx) => {
    // pickUpLocation HER ZAMAN dolu olmalı
    if (data.pickUpLocation === null || !data?.pickUpLocation?.id) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["pickUpLocation"],
        message: "pickUpLocationEmptyError",
      });
    }

    // isDifferentLocation true ise dropOffLocation zorunlu
    if (data.isDifferentLocation && data.dropOffLocation === null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["dropOffLocation"],
        message: "dropOffLocationEmptyError",
      });
    }
  });

export default carSearchSchema;

export const defaultDriverAge = "30-65";
